import { Select } from "antd";
import PropTypes from "prop-types";
import { useMemo } from "react";

// IDCC référentiel is not backed by the API (no getIdccList query yet), so this
// select no longer fetches options. Existing codes still display; adding new
// ones from a list is disabled until a référentiel exists.
const InsurancePlanIdccRuleSelect = ({
  value,
  onChange,
  placeholder,
  className,
}) => {
  const options = useMemo(
    () =>
      (Array.isArray(value) ? value : [])
        .filter(Boolean)
        .map((code) => ({ value: code, label: code })),
    [value],
  );

  return (
    <Select
      mode="multiple"
      allowClear
      className={className}
      placeholder={placeholder}
      options={options}
      value={value || []}
      onChange={onChange}
      maxTagCount="responsive"
    />
  );
};

InsurancePlanIdccRuleSelect.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  className: PropTypes.string,
};

InsurancePlanIdccRuleSelect.defaultProps = {
  value: [],
  placeholder: "",
  className: "w-100",
};

export default InsurancePlanIdccRuleSelect;
